export default __webpack_public_path__ + "static/media/trailer.23aa0527.mp4";